interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  /** `inline`: niente position fixed (per header maxi schermo). */
  variant?: 'fixed' | 'inline';
  className?: string;
}

const SIZES: Record<NonNullable<LogoProps['size']>, number> = {
  small: 80,
  medium: 120,
  large: 160,
};

export default function Logo({ size = 'medium', variant = 'fixed', className }: LogoProps) {
  const width = SIZES[size];
  const fixedWrap =
    variant === 'fixed'
      ? {
          position: 'fixed' as const,
          top: '2rem',
          left: '2rem',
          zIndex: 1000,
        }
      : {};
  return (
    <a
      href="/"
      aria-label="Italian Prompt Battle - Home"
      className={className}
      style={{
        ...fixedWrap,
        width: `${width}px`,
        height: 'auto',
        opacity: 0.9,
        display: 'inline-block',
        lineHeight: 0,
      }}
    >
      <img
        src="/logo.svg"
        alt=""
        aria-hidden
        decoding="async"
        style={{ width: '100%', height: 'auto', display: 'block' }}
      />
    </a>
  );
}
